package hk.com.vr360_demo2.webapp.component.viewer.component

import hk.com.vr360_demo2.webapp.component.dialog.BaseDialog
import emotion.react.css
import react.FC
import react.Props
import react.dom.html.ReactHTML
import react.dom.html.ReactHTML.button
import react.dom.html.ReactHTML.canvas
import react.useEffect
import react.useRef
import react.useState
import web.cssom.*
import kotlin.js.json
import web.html.HTMLCanvasElement
import kotlinx.browser.document
import org.w3c.dom.HTMLInputElement
import react.Fragment
import react.Ref
import react.create
import kotlinx.browser.window
import hk.com.vr360_demo2.webapp.component.ToastProvider
import hk.com.vr360_demo2.webapp.component.useToast

@JsModule("qrcode")
@JsNonModule
external object QRCode {
    fun toCanvas(canvas: dynamic, text: String, options: dynamic = definedExternally, callback: ((dynamic) -> Unit)? = definedExternally)
}

external interface ShareDialogProps : Props {
    var show: Boolean
    var url: String
    var onClose: () -> Unit
}

val ShareDialog = FC<ShareDialogProps> { props ->
    val toast = useToast()
    val canvasRef = useRef<HTMLCanvasElement>(null)
    val currentUrl = window.location.href

    fun fallbackCopy(text: String): Boolean {
        return try {
            val tempInput = document.createElement("input") as HTMLInputElement
            tempInput.value = text
            document.body?.appendChild(tempInput)
            tempInput.select()
            val copied = document.execCommand("copy")
            document.body?.removeChild(tempInput)
            copied
        } catch (_: Throwable) {
            false
        }
    }

    fun handleCopy() {
        val nav = js("navigator")
        val clipboard = nav.clipboard

        if (clipboard != undefined && clipboard.writeText != undefined) {
            clipboard.writeText(currentUrl).then {
                toast("連結已複製到剪貼簿", "success")
            }.catch {
                val copied = fallbackCopy(currentUrl)
                if (copied) {
                    toast("連結已複製到剪貼簿", "success")
                } else {
                    toast("複製失敗，請手動複製", "error")
                }
            }
        } else {
            val copied = fallbackCopy(currentUrl)
            if (copied) {
                toast("連結已複製到剪貼簿", "success")
            } else {
                toast("瀏覽器不支持自動複製，請手動複製", "warning")
            }
        }
    }

    useEffect(listOf(currentUrl, props.show)) {
        if (props.show && currentUrl.isNotEmpty()) {
            val canvas = canvasRef.current
            if (canvas != null) {
                QRCode.toCanvas(canvas, currentUrl, json("width" to 120, "margin" to 1)) { err ->
                    if (err != null) console.error(err)
                }
            }
        }
    }

    BaseDialog {
        show = props.show
        title = "分享至"
        onClose = props.onClose
        content = Fragment.create {
            // Snackbar 移除，改用全局 ToastProvider
            ReactHTML.div {
                css {
                    display = Display.flex
                    flexDirection = FlexDirection.column
                    alignItems = AlignItems.center
                }
                ReactHTML.div {
                    css {
                        width = 100.pct
                        textAlign = TextAlign.left
                        color = Color("#333")
                        fontSize = 14.px
                        marginBottom = 6.px
                        marginTop = 16.px
                        fontWeight = FontWeight.bold
                    }
                    +"項目連接"
                }
                ReactHTML.div {
                    css {
                        display = Display.flex
                        width = 100.pct
                        alignItems = AlignItems.center
                        marginBottom = 18.px
                    }
                    ReactHTML.input {
                        css {
                            asDynamic().flexGrow = 1.0
                            fontSize = 15.px
                            padding = Padding(7.px, 10.px)
                            borderRadius = 6.px
                            border = Border(1.px, LineStyle.solid, Color("#e0e0e0"))
                            background = Color.transparent
                            color = Color("#f26522")
                            marginRight = 10.px
                            focus {
                                outline = None.none
                                border = Border(1.px, LineStyle.solid, Color("#f26522"))
                            }
                        }
                        asDynamic().type = "text"
                        value = currentUrl
                        readOnly = true
                    }
                    button {
                        css {
                            background = Color("#f26522")
                            color = Color("#fff")
                            border = 0.px
                            borderRadius = 6.px
                            padding = Padding(7.px, 16.px)
                            fontSize = 15.px
                            fontWeight = FontWeight.bold
                            cursor = Cursor.pointer
                            focus {
                                outline = None.none
                                border = 0.px
                            }
                        }
                        onClick = { handleCopy() }
                        +"複製"
                    }
                }
                ReactHTML.div {
                    css {
                        marginTop = 8.px
                        display = Display.flex
                        justifyContent = JustifyContent.center
                        alignItems = AlignItems.center
                        width = 100.pct
                    }
                    canvas {
                        ref = canvasRef.unsafeCast<Ref<HTMLCanvasElement>>()
                        width = 120.0
                        height = 120.0
                        css {
                            width = 120.px
                            height = 120.px
                            background = Color("#fff")
                            borderRadius = 8.px
                            border = Border(1.px, LineStyle.solid, Color("#eee"))
                        }
                    }
                }
                ReactHTML.div {
                    css {
                        width = 100.pct
                        textAlign = TextAlign.center
                        color = Color("#333")
                        fontSize = 13.px
                        marginBottom = 10.px
                        marginTop = 10.px
                    }
                    +"掃描二維碼，手機打開並分享"
                }
            }
        }
    }
}
